import { render, staticRenderFns } from "./CouponUseItem.vue?vue&type=template&id=4e04f12a&"
import script from "./CouponUseItem.vue?vue&type=script&lang=ts&"
export * from "./CouponUseItem.vue?vue&type=script&lang=ts&"
import style0 from "./CouponUseItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports